/**
 * OrbDocIndexAROrbDocIndexARPage
 *
 * Page component for OrbDocIndexAROrbDocIndexARPage
 * Path: /ar/docs
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbDocIndexARDocScreenView as __OrbDocIndexARDocScreenView } from '@/components/traits/OrbDocIndexARDocScreenView';
import { OrbDocIndexARDocAnalyticsView as __OrbDocIndexARDocAnalyticsView } from '@/components/traits/OrbDocIndexARDocAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface OrbDocIndexAROrbDocIndexARPageProps {
  // Add any page-level props here
}

export function OrbDocIndexAROrbDocIndexARPage(_props: OrbDocIndexAROrbDocIndexARPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"توثيق Orb","description":"تعلّم اللغة، وركّب المكتبة القياسية، وارجع إلى كل عامل وكل سلوك.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/docs"},{"locale":"ar","path":"/ar/docs"},{"locale":"sl","path":"/sl/docs"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbDocIndexARDocScreenView config={{ initPayload: __navState }} />
          <__OrbDocIndexARDocAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default OrbDocIndexAROrbDocIndexARPage;
